/**
 * Business admin model.
 */
export class BusinessAdmin {
  /**
   * Recid/AOPA Member number for admin.
   */
  recid: number;

  /**
   * Admin's first name, from Personify
   */
  firstName: string;

  /**
   * Admin's last name, from Personify
   */
  lastName: string;

  /**
   * is admin a Primary POC for this business, from Personify
   */
  primaryPoc: boolean;

  /**
   * is admin a FBO fee POC for this business, from Personify
   */
  fboFeePoc: boolean;

  /**
   * Date record was created
   */
  createdDate: Date;

  /**
   * The user who created the record
   */
  createdBy: string;

  /**
   * Date record was last updated
   */
  modifiedDate: Date;

  /**
   * The user who last updated the record
   */
  modifiedBy: string;

  /**
   * Parses contact
   * @param data {any} Contact data as returned by API
   * @return {BusinessContact} Parsed contact
   */
  static parse(data: any): BusinessAdmin {
    return {
      recid: data.recid,
      firstName: data.firstName,
      lastName: data.lastName,
      primaryPoc: data.primaryPoc,
      fboFeePoc: data.fboFeePoc,
      createdDate: data.createdDate ? new Date(data.createdDate) : null,
      createdBy: data.createdBy,
      modifiedDate: data.modifiedDate ? new Date(data.modifiedDate) : null,
      modifiedBy: data.modifiedBy
    };
  }
}
